(function() {
  var preguntas = [
    {
      id: 'p1',
      texto: '¿Cómo te gustaría sentirte cuando percibas tu aroma?',
      opciones: [
        'En calma y relajada',
        'Con energía y buen ánimo',
        'Con claridad y concentración',
        'Arropada y confortable',
        'Fresca y revitalizada',
        'En un ambiente íntimo y especial',
        'Con sensación de limpieza y orden',
        'Rodeada de elegancia y sofisticación'
      ],
      mapa: {
        'En calma y relajada':                    'Calma y relajación',
        'Con energía y buen ánimo':               'Energía y ánimo',
        'Con claridad y concentración':           'Claridad y concentración',
        'Arropada y confortable':                 'Confort y acogimiento',
        'Fresca y revitalizada':                  'Frescura y limpieza',
        'En un ambiente íntimo y especial':       'Sensualidad e intimidad',
        'Con sensación de limpieza y orden':      'Limpieza y orden',
        'Rodeada de elegancia y sofisticación':   'Elegancia y sofisticación'
      }
    },
    {
      id: 'p2',
      texto: '¿En qué momento quieres disfrutarlo principalmente?',
      opciones: [
        'Al comenzar el día',
        'Mientras trabajo o estudio',
        'Después de limpiar o ventilar la casa',
        'Al llegar a casa y desconectar',
        'Durante un momento de lectura, descanso o autocuidado',
        'Cuando recibo visitas o quiero crear un ambiente especial'
      ],
      mapa: {
        'Al comenzar el día':                                              'Activación',
        'Mientras trabajo o estudio':                                      'Concentración',
        'Después de limpiar o ventilar la casa':                           'Hogar limpio',
        'Al llegar a casa y desconectar':                                  'Desconexión',
        'Durante un momento de lectura, descanso o autocuidado':           'Relax',
        'Cuando recibo visitas o quiero crear un ambiente especial':       'Ambiente especial'
      }
    },
    {
      id: 'p3',
      texto: '¿Qué tipo de aromas disfrutas más?',
      subtexto: 'Puedes elegir hasta 2.',
      opciones: [
        'Limpios, frescos y aireados',
        'Cítricos, frescos y luminosos',
        'Florales, suaves y delicados',
        'Verdes, herbales y naturales',
        'Frutales, jugosos y alegres',
        'Dulces, cremosos y golosos',
        'Amaderados, cálidos y envolventes',
        'Marinos, frescos y acuáticos',
        'Especiados, cálidos y con carácter'
      ],
      mapa: {
        'Limpios, frescos y aireados':        'Limpia',
        'Cítricos, frescos y luminosos':      'Cítrica',
        'Florales, suaves y delicados':       'Floral',
        'Verdes, herbales y naturales':       'Herbal',
        'Frutales, jugosos y alegres':        'Afrutada',
        'Dulces, cremosos y golosos':         'Dulce/Gourmand',
        'Amaderados, cálidos y envolventes':  'Amaderada',
        'Marinos, frescos y acuáticos':       'Marina',
        'Especiados, cálidos y con carácter': 'Especiada'
      },
      maxSelecciones: 2
    },
    {
      id: 'p4',
      texto: '¿Qué intensidad prefieres?',
      opciones: [
        'Suave y discreta',
        'Equilibrada',
        'Intensa y con presencia'
      ],
      mapa: {
        'Suave y discreta':        'Suave',
        'Equilibrada':             'Media',
        'Intensa y con presencia': 'Intensa'
      }
    },
    {
      id: 'p5',
      texto: '¿Cuál de estos caracteres olfativos te atrae más?',
      opciones: [
        'Fresco y mentolado',
        'Fresco y aéreo',
        'Floral suave',
        'Floral intenso',
        'Herbal y aromático',
        'Cítrico y luminoso',
        'Dulce y cremoso',
        'Amaderado y cálido',
        'Especiado y con carácter'
      ],
      mapa: {
        'Fresco y mentolado':        'fresco_mentolado',
        'Fresco y aéreo':            'fresco_aereo',
        'Floral suave':              'floral_suave',
        'Floral intenso':            'floral_intenso',
        'Herbal y aromático':        'herbal_aromatico',
        'Cítrico y luminoso':        'citrico_luminoso',
        'Dulce y cremoso':          'dulce_cremoso',
        'Amaderado y cálido':       'amaderado_calido',
        'Especiado y con carácter': 'especiado_caracter'
      }
    }
  ];

  var maticesEquivalentes = {
    'Limpia':         ['Limpia','Jabonosa','Algodonada'],
    'Cítrica':        ['Cítrica'],
    'Floral':         ['Floral'],
    'Herbal':         ['Herbal','Aromática','Verde'],
    'Afrutada':       ['Afrutada'],
    'Dulce/Gourmand': ['Dulce','Cremosa','Avainillada','Golosa'],
    'Amaderada':      ['Amaderada'],
    'Marina':         ['Acuosa','Marina'],
    'Especiada':      ['Especiada']
  };

  var intensidadOrden = { 'Suave': 0, 'Media': 1, 'Intensa': 2 };

  var currentStep = 0;
  var respuestas = {};

  var styleNormal   = 'display:inline-block;padding:10px 20px;border:1px solid #ccc;background:#fff;cursor:pointer;font-size:13px;letter-spacing:0.04em;border-radius:2px;color:#1a1a1a;margin:0;white-space:normal;text-align:center;line-height:1.4;';
  var styleSelected = 'display:inline-block;padding:10px 20px;border:1px solid #1a1a1a;background:#1a1a1a;cursor:pointer;font-size:13px;letter-spacing:0.04em;border-radius:2px;color:#fff;margin:0;white-space:normal;text-align:center;line-height:1.4;';

  function valorP1() { return preguntas[0].mapa[respuestas.p1] || null; }
  function valorP2() { return preguntas[1].mapa[respuestas.p2] || null; }
  function valoresP3() {
    var sels = respuestas.p3 || [];
    return sels.map(function(s) { return preguntas[2].mapa[s] || null; }).filter(Boolean);
  }
  function valorP4() { return preguntas[3].mapa[respuestas.p4] || null; }
  function valorP5() { return preguntas[4] && preguntas[4].mapa[respuestas.p5] || null; }

  function tieneMatiz(aroma, familia) {
    var equivalentes = maticesEquivalentes[familia] || [];
    if (!Array.isArray(aroma.matices)) return false;
    for (var i = 0; i < aroma.matices.length; i++) {
      if (equivalentes.indexOf(aroma.matices[i]) !== -1) return true;
    }
    return false;
  }

  // P3 + P5 determine affinity; emotional/use preferences never override it.
  function normalizarCaracter(value) {
    if (typeof value !== 'string') return null;
    value = value.trim();
    if (preguntas[4].mapa[value]) return preguntas[4].mapa[value];
    return Object.keys(preguntas[4].mapa).some(function(label) {
      return preguntas[4].mapa[label] === value;
    }) ? value : null;
  }

  function normalizarIntensidad(value) {
    return value === 'Equilibrada' ? 'Media' : value;
  }

  function calcularPuntuacion(aroma) {
    var familias = valoresP3();
    var familia = familias.indexOf(aroma.familia) !== -1 ? 6 :
      familias.some(function(f) { return tieneMatiz(aroma, f); }) ? 3 : 0;
    var caracter = valorP5();
    var puntosCaracter = caracter && normalizarCaracter(aroma.caracter_olfativo_principal) === caracter ? 4 :
      caracter && normalizarCaracter(aroma.caracter_olfativo_secundario) === caracter ? 2 : 0;
    return familia + puntosCaracter;
  }

  function calcularDesempate(aroma) {
    var p1 = valorP1(), p2 = valorP2(), p4 = valorP4();
    var afinado = p1 && aroma.perfil_principal === p1 ? 5 :
      p1 && aroma.perfil_secundario === p1 ? 2 : 0;
    if (p2 && Array.isArray(aroma.momento_de_uso) && aroma.momento_de_uso.indexOf(p2) !== -1) afinado += 3;
    var intensidad = normalizarIntensidad(aroma.intensidad);
    if (p4 && intensidad === p4) afinado += 1;
    var conocida = Object.prototype.hasOwnProperty.call(intensidadOrden, intensidad);
    var proximidad = p4 && conocida ? 2 - Math.abs(intensidadOrden[intensidad] - intensidadOrden[p4]) : -1;
    return [afinado, proximidad];
  }

  function compararTexto(a, b) {
    a = String(a || ''); b = String(b || '');
    return a < b ? -1 : a > b ? 1 : 0;
  }

  function seleccionarAromas(aromas) {
    if (!Array.isArray(aromas)) return [];
    var puntuados = aromas.filter(function(a) { return a && typeof a === 'object'; }).map(function(a) {
      return { aroma: a, score: calcularPuntuacion(a), ajuste: calcularDesempate(a) };
    }).filter(function(item) { return item.score > 0; });
    puntuados.sort(function(a, b) {
      if (a.score !== b.score) return b.score - a.score;
      for (var i = 0; i < a.ajuste.length; i++) {
        if (a.ajuste[i] !== b.ajuste[i]) return b.ajuste[i] - a.ajuste[i];
      }
      // Only a verified, aroma-specific availability boolean may break a tie.
      // Generic associated product stock is not evidence of aroma availability.
      var avA = a.aroma.disponibilidad_aroma_verificada;
      var avB = b.aroma.disponibilidad_aroma_verificada;
      var disponibleA = avA === true ? 1 : 0;
      var disponibleB = avB === true ? 1 : 0;
      if (disponibleA !== disponibleB) return disponibleB - disponibleA;
      return compararTexto(a.aroma.codigo, b.aroma.codigo) ||
        compararTexto(a.aroma.id, b.aroma.id) || compararTexto(a.aroma.nombre, b.aroma.nombre);
    });
    return puntuados.slice(0, 3);
  }

  var VERSION_RESULTADOS = 2;
  // Separate namespace: never read, overwrite or delete the live v1 key.
  var CLAVE_RESULTADOS = 'lfe_test_resultado_v2_' + String(window.aromaTestThemeId || 'pruebas');

  function guardarRespuestas() {
    try {
      localStorage.setItem(CLAVE_RESULTADOS, JSON.stringify({version: VERSION_RESULTADOS, respuestas: respuestas}));
    } catch (e) {}
  }

  function leerRespuestas() {
    try {
      var saved = JSON.parse(localStorage.getItem(CLAVE_RESULTADOS));
      if (!saved || saved.version !== VERSION_RESULTADOS || !saved.respuestas) return null;
      var r = saved.respuestas;
      if (!preguntas[0].mapa[r.p1] || !preguntas[1].mapa[r.p2] ||
          !preguntas[3].mapa[r.p4] || !preguntas[4].mapa[r.p5] ||
          !Array.isArray(r.p3) || r.p3.length < 1 || r.p3.length > 2 ||
          r.p3.some(function(v) { return !preguntas[2].mapa[v]; }) ||
          r.p3.length === 2 && r.p3[0] === r.p3[1]) return null;
      return {p1:r.p1, p2:r.p2, p3:r.p3.slice(), p4:r.p4, p5:r.p5};
    } catch (e) { return null; }
  }

  function actualizarNav() {
    var p = preguntas[currentStep];
    var seleccionado = p.id === 'p3'
      ? (respuestas.p3 && respuestas.p3.length > 0)
      : !!respuestas[p.id];
    var prevBtn   = document.getElementById('test-aroma-prev');
    var nextBtn   = document.getElementById('test-aroma-next');
    var submitBtn = document.getElementById('test-aroma-submit');
    if (prevBtn)   prevBtn.setAttribute('style',   (currentStep > 0 ? 'display:inline-block;' : 'display:none!important;') + 'padding:12px 28px;font-size:12px;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;border:1px solid #ccc;background:#fff;color:#1a1a1a;border-radius:2px;');
    if (nextBtn)   nextBtn.setAttribute('style',   (currentStep < preguntas.length - 1 && seleccionado ? 'display:inline-block;' : 'display:none!important;') + 'padding:12px 28px;font-size:12px;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;border:1px solid #1a1a1a;background:#1a1a1a;color:#fff;border-radius:2px;');
    if (submitBtn) submitBtn.setAttribute('style', (currentStep === preguntas.length - 1 && seleccionado ? 'display:inline-block;' : 'display:none!important;') + 'padding:12px 28px;font-size:12px;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;border:1px solid #1a1a1a;background:#1a1a1a;color:#fff;border-radius:2px;');
  }

  function mostrarPregunta(index) {
    var welcomeEl  = document.getElementById('test-aroma-welcome');
    var p          = preguntas[index];
    var progressEl = document.getElementById('test-aroma-progress');
    var questionEl = document.getElementById('test-aroma-question');
    var optsEl     = document.getElementById('test-aroma-options');
    var navEl      = document.getElementById('test-aroma-nav');

    if (welcomeEl)  welcomeEl.style.display  = 'none';
    if (progressEl) progressEl.style.display = 'block';
    if (questionEl) questionEl.style.display = 'block';
    if (navEl)      navEl.style.display      = 'flex';

    if (progressEl) progressEl.innerHTML = 'Pregunta ' + (index + 1) + ' de ' + preguntas.length;

    var subtextoHTML = p.subtexto
      ? '<p style="font-size:13px;color:#999;margin:0 0 20px;letter-spacing:0.02em;">' + p.subtexto + '</p>'
      : '';
    if (questionEl) questionEl.innerHTML =
      '<h2 style="font-size:clamp(16px,2.5vw,24px);font-weight:400;letter-spacing:0.04em;max-width:600px;line-height:1.3;margin-bottom:12px;">' + p.texto + '</h2>' +
      subtextoHTML;

    if (optsEl) {
      optsEl.setAttribute('style', 'display:flex;flex-wrap:wrap;gap:10px;margin-bottom:8px;');
      optsEl.innerHTML = '';

      if (p.id === 'p3') {
        var seleccionadas = respuestas.p3 || [];
        p.opciones.forEach(function(op) {
          var btn = document.createElement('button');
          btn.textContent = op;
          btn.className = 'test-aroma-opcion';
          btn.setAttribute('style', seleccionadas.indexOf(op) !== -1 ? styleSelected : styleNormal);
          btn.addEventListener('click', function() {
            var idx = seleccionadas.indexOf(op);
            if (idx !== -1) {
              seleccionadas.splice(idx, 1);
              btn.setAttribute('style', styleNormal);
            } else {
              if (seleccionadas.length < 2) {
                seleccionadas.push(op);
                btn.setAttribute('style', styleSelected);
              }
            }
            respuestas.p3 = seleccionadas.slice();
            actualizarNav();
          });
          optsEl.appendChild(btn);
        });
      } else {
        p.opciones.forEach(function(op) {
          var btn = document.createElement('button');
          btn.textContent = op;
          btn.className = 'test-aroma-opcion';
          btn.setAttribute('style', respuestas[p.id] === op ? styleSelected : styleNormal);
          btn.addEventListener('click', function() {
            var allBtns = document.querySelectorAll('.test-aroma-opcion');
            for (var i = 0; i < allBtns.length; i++) allBtns[i].setAttribute('style', styleNormal);
            btn.setAttribute('style', styleSelected);
            respuestas[p.id] = op;
            actualizarNav();
          });
          optsEl.appendChild(btn);
        });
      }
    }
    actualizarNav();
  }

  function mostrarBienvenida() {
    var welcomeEl  = document.getElementById('test-aroma-welcome');
    var progressEl = document.getElementById('test-aroma-progress');
    var questionEl = document.getElementById('test-aroma-question');
    var optsEl     = document.getElementById('test-aroma-options');
    var navEl      = document.getElementById('test-aroma-nav');
    if (progressEl) progressEl.style.display = 'none';
    if (questionEl) questionEl.style.display = 'none';
    if (optsEl)     optsEl.style.display     = 'none';
    if (navEl)      navEl.style.display      = 'none';
    if (welcomeEl)  welcomeEl.style.display  = 'block';
  }

  function construirBotones(productos) {
    if (!productos || productos.length === 0) return '';
    return '<div class="test-aroma-formatos">' +
      productos.map(function(p) {
        return '<a href="' + p.url + '" class="test-aroma-formato-btn" target="_blank" rel="noopener">' + p.titulo + '</a>';
      }).join('') +
      '</div>';
  }

  function mostrarResultados() {
    var top3 = seleccionarAromas(window.aromasData);
    guardarRespuestas();
    ['test-aroma-welcome', 'test-aroma-question', 'test-aroma-options', 'test-aroma-nav', 'test-aroma-progress'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });
    var resEl = document.getElementById('test-aroma-results');
    if (resEl) {
      resEl.style.display = 'block';
      renderizarResultados(resEl, top3);
    }
  }

  function renderizarResultados(resEl, top3) {
    var tarjetas = top3.map(function(item, i) {
      var productos = Array.isArray(item.aroma.productos) ? item.aroma.productos.filter(function(p) {
        return p && typeof p.url === 'string' && /^(\/[^/]|https:\/\/)/.test(p.url) && typeof p.titulo === 'string';
      }) : [];
      var botonesHTML = productos.length > 0
        ? '<div class="test-aroma-formatos">' +
          productos.map(function(p) {
            var url = p.url + (p.url.indexOf('?') === -1 ? '?' : '&') + 'from=test-aroma';
                        return '<a href="' + url + '" class="test-aroma-formato-btn" target="_blank" rel="noopener">' + p.titulo + '</a>';
          }).join('') +
          '</div>'
        : '';

      if (i === 0) {
        return '<div class="test-aroma-resultado test-aroma-resultado--principal">' +
          '<p class="test-aroma-resultado-label">Tu aroma ideal</p>' +
          '<h3>' + item.aroma.nombre + '</h3>' +
          '<p class="test-aroma-resultado-desc">' + (item.aroma.descripcion || '') + '</p>' +
          botonesHTML +
          '</div>';
      } else {
        return '<div class="test-aroma-resultado test-aroma-resultado--secundario">' +
          '<h3>' + item.aroma.nombre + '</h3>' +
          '<p class="test-aroma-resultado-desc">' + (item.aroma.descripcion || '') + '</p>' +
          botonesHTML +
          '</div>';
      }
    });
           var bloqueAccion = '<div class="test-aroma-cta" style="margin-top:32px;text-align:center;"><p style="margin:0;"><a href="javascript:void(0)" id="test-aroma-reiniciar" style="font-size:12px;color:#999;letter-spacing:0.06em;text-decoration:underline;cursor:pointer;">Volver a hacer el test</a></p></div>';
    var mensajeVacio = top3.length === 0 ? '<p role="status">No hemos encontrado afinidades con los datos disponibles. Prueba otra combinación de preferencias.</p>' : '';
    resEl.innerHTML = mensajeVacio + '<div class="test-aroma-resultados-grid">' + tarjetas.join('') + '</div>' + bloqueAccion;



    
     

    var reiniciarBtn = document.getElementById('test-aroma-reiniciar');
    if (reiniciarBtn) {
      reiniciarBtn.addEventListener('click', function() {
        try { localStorage.removeItem(CLAVE_RESULTADOS); } catch(e) {}
        currentStep = 0;
        respuestas = {};
        resEl.style.display = 'none';
        mostrarBienvenida();
      });
    }
  }



  document.addEventListener('DOMContentLoaded', function() {
    if (!document.getElementById('test-aroma-container')) return;
    var saved = leerRespuestas();
    if (saved && new URLSearchParams(window.location.search).get('restaurar') === '1') {
      respuestas = saved;
      // Recompute using current metaobjects and product references, not stale cards.
      mostrarResultados();
    } else {
      mostrarBienvenida();
    }
    var startBtn = document.getElementById('test-aroma-start');
    var prevBtn = document.getElementById('test-aroma-prev');
    var nextBtn = document.getElementById('test-aroma-next');
    var submitBtn = document.getElementById('test-aroma-submit');
    if (startBtn) startBtn.addEventListener('click', function() {
      currentStep = 0; respuestas = {}; mostrarPregunta(0);
    });
    if (prevBtn) prevBtn.addEventListener('click', function() {
      if (currentStep > 0) { currentStep--; mostrarPregunta(currentStep); }
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      if (currentStep < preguntas.length - 1) { currentStep++; mostrarPregunta(currentStep); }
    });
    if (submitBtn) submitBtn.addEventListener('click', mostrarResultados);
  });
})();
